import {
  FilterWidgetFormFieldPathType,
  IFilterPredicate,
  IPredicateFormFieldPath,
} from '../../../types';
import * as FilterWidgetPredicateUI from './FilterWidgetPredicateUI';
import { IndexedIcon } from '../../../../Icon';
import { Controller } from 'react-hook-form';
import FilterWidgetLogicOp from '../../FilterWidgetLogicOp';
import FilterWidgetSimplePredicate from './FilterWidgetSimplePredicate';
import { TextButton } from '../../../../Button';
import React from 'react';
import useFilterWidgetFormContext from '../../../utils/useFilterWidgetFormContext';
import KubitTooltip from '../../../../KubitTooltip';

interface IProps {
  rootPredicate: IFilterPredicate;
  conditionIndex: number;
  predicateIndex: number;
  onResetField: () => void;
  onRemove: () => void;
  disableRemove: boolean;
  onUpdateRootPredicate: (newPredicate: IFilterPredicate) => void;
  allowMorePredicates: boolean;
  onAddPredicate: () => void;
}

const FilterWidgetSinglePredicate = ({
  rootPredicate,
  conditionIndex,
  predicateIndex,
  onResetField,
  onRemove,
  disableRemove,
  onUpdateRootPredicate,
  allowMorePredicates,
  onAddPredicate,
}: IProps) => {
  const { control } = useFilterWidgetFormContext();

  const formPath: IPredicateFormFieldPath = {
    type: FilterWidgetFormFieldPathType.SimplePredicate,
    conditionIndex,
    predicateIndex,
  };
  return (
    <FilterWidgetPredicateUI.SimplePredicateContainerList>
      <FilterWidgetPredicateUI.PredicateListIconContainer>
        <FilterWidgetPredicateUI.IconWrapper>
          {predicateIndex === 0 ? (
            <IndexedIcon
              name="filter"
              positiveIndex={conditionIndex + 1}
              isActive={true}
            />
          ) : (
            <Controller
              name={`conditions.${conditionIndex}.logicOps.${predicateIndex - 1}`}
              control={control}
              render={({ field: { value, onChange } }) => (
                <FilterWidgetLogicOp
                  type="predicate"
                  operator={value}
                  onChange={onChange}
                />
              )}
            />
          )}
        </FilterWidgetPredicateUI.IconWrapper>
        <FilterWidgetSimplePredicate
          formPath={formPath}
          rootPredicate={rootPredicate}
          onUpdateRootPredicate={onUpdateRootPredicate}
          disableRemove={disableRemove}
          onRemove={onRemove}
          onResetField={onResetField}
        />
      </FilterWidgetPredicateUI.PredicateListIconContainer>
      <FilterWidgetPredicateUI.PredicateListFooter>
        {allowMorePredicates && (
          <KubitTooltip content={'Apply another filter'} placement="bottom">
            <TextButton onClick={onAddPredicate}>+ Filter</TextButton>
          </KubitTooltip>
        )}
      </FilterWidgetPredicateUI.PredicateListFooter>
    </FilterWidgetPredicateUI.SimplePredicateContainerList>
  );
};

export default FilterWidgetSinglePredicate;
